import { CanLoad, Route, Router, UrlSegment } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { map, take } from 'rxjs/operators';

import { UserState } from './state/auth.reducer';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthentificationGuard implements CanLoad {
  constructor(
    private store: Store<{ user: UserState }>,
    private router: Router,
  ) {}

  canLoad(
    route: Route,
    segments: UrlSegment[],
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.store.pipe(
      select((state) => state.user),
      //filter(authState => authState.isAuthChecked), // Only proceed when isAuthChecked is true
      take(1),
      map((userState) => {
        if (userState.isAuthChecked && userState.isAuthenticated) {
          // If the auth state has been checked and the user is authenticated, allow access
          return true;
        } else {
          // If the auth state has been checked and the user is not authenticated, redirect to login
          this.router.navigate(['/auth']);
          return false;
        }
      }),
    );
  }
}
